import React from 'react';
import cx from 'classnames';
import { flattenToAppURL } from '@plone/volto/helpers';

const safe = (s) => (typeof s === 'string' ? s : '');

const ImageCopyright = ({ text }) => {
  const [open, setOpen] = React.useState(false);

  if (!text) return null;

  const toggle = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setOpen((o) => !o);
  };

  return (
    <div
      className={cx('fcmh-timeline__copyright', { 'is-open': open })}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="fcmh-timeline__copyright-icon"
        aria-label="Bildnachweis anzeigen"
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.stopPropagation();
            setOpen(false);
          }
        }}
      >
        ©
      </button>

      <div className="fcmh-timeline__copyright-tooltip" role="tooltip">
        <span className="fcmh-timeline__copyright-text">{text}</span>
      </div>
    </div>
  );
};

const getBgClass = (backgroundColor) => {
  const bg = backgroundColor || 'white';
  return `fcmh-timeline--bg-${bg}`;
};

const TimelineView = (props) => {
  const { data = {} } = props;
  const { headline, backgroundColor, items = [] } = data;

  if (!headline && (!items || items.length === 0)) return null;

  return (
    <section className={`fcmh-timeline ${getBgClass(backgroundColor)}`}>
      <div className="fcmh-timeline__inner">
        {headline && <h2 className="fcmh-timeline__headline">{headline}</h2>}

        <div className="fcmh-timeline__content">
          <div className="fcmh-timeline__line" />
          <div className="fcmh-timeline__items">
            {items.map((item, index) => {
              const side =
                item.position ||
                item.side ||
                (index % 2 === 0 ? 'left' : 'right');

              return (
                <div
                  key={index}
                  className={`fcmh-timeline__item fcmh-timeline__item--${side}`}
                >
                  <div className="fcmh-timeline__bullet" />
                  <div className="fcmh-timeline__text">
                    {item.title && (
                      <div className="fcmh-timeline__title">{item.title}</div>
                    )}
                    {item.description && (
                      <div className="fcmh-timeline__description">
                        {item.description}
                      </div>
                    )}

                    {item.image &&
                      (() => {
                        let imageUrl =
                          item.image?.download ||
                          item.image?.['@id'] ||
                          (Array.isArray(item.image) &&
                            item.image[0]?.['@id']) ||
                          item.image?.url;

                        if (imageUrl) {
                          imageUrl = flattenToAppURL(imageUrl);

                          if (
                            !imageUrl.includes('@@images') &&
                            !imageUrl.includes('/@@download')
                          ) {
                            imageUrl = `${imageUrl}/@@images/image`;
                          }
                        }

                        const copyrightText = safe(item?.copyrightText).trim();

                        return imageUrl ? (
                          <div className="fcmh-timeline__image">
                            <img
                              src={imageUrl}
                              alt={item.image?.title || item.title || ''}
                              loading="lazy"
                            />
                            <ImageCopyright text={copyrightText} />
                          </div>
                        ) : null;
                      })()}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelineView;
